import React, {lazy, Suspense } from 'react';
import Dashboard from '../../components/Dashboard/Dashboard';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const WishList = lazy(()=>import('../../components/Dashboard/WishList'))

const WishListPage = () => {
    return (
        <Dashboard>
            <Suspense fallback={<LazyLoader/>}>
                <WishList/>
            </Suspense>
        </Dashboard>
    );
};

export default WishListPage;